(ns dre.panels.sense-detail.views
  (:require 
   [dre.pages.dictionary.views :as main]))

(defn view
  []
  [:div
   {:class :dictionary-panel}
   [main/view]])
